// extracted by mini-css-extract-plugin
export default {"heading":"_de060d08"};